import React, { Component } from "react";
import Header from "../Header";
import Menu from "../Menu";
import { Link } from "react-router-dom";
import "../../assets/css/question.css";
import "../../assets/css/new_style.css";
import "../../assets/css/custom.css";
import {SURGEON} from './../../services/Surgeon';

class Complains extends Component {
  constructor(props) {
    super(props);
    this.state = {
      nextStep:'',
      patientId:'',
      isLoading:true,
    };
    this.handleAction = this.handleAction.bind(this);
    this.goNextStep   = this.goNextStep.bind(this);
  }
  componentWillMount()
  { 
    try {
      this.setState({
        narrativeSummary: this.props.location.state.patientData.narrative_summary,
      });
    } catch (e) {
      this.props.history.push('/surgeon/patients/');
    }
    let id  = this.props.location.pathname.split('/');
    id      = id[(id.length)-1];
    this.setState({
      patientId:id
    })

    let patientData = SURGEON.getPatientDetail(id).then(res => {
      if(res.data.header.error==0)
      { 
        this.setState({
            patientData: res.data.body.details,
            isLoading: false,
            
        });
      }
      else
      {
        this.props.history.push({
          pathname: '/surgeon/patients'
        })
      }
  }).catch(err => {
      return err;
  });
  }
  goNextStep= (e)=>
  { 
    if(this.state.nextStep)
    { 
      
      this.props.history.push({
        pathname: '/surgeon/'+this.state.nextStep+'/'+this.state.patientId,
        state: { patientData:this.props.location.state.patientData},
      });
    }
    
  }
  handleAction = (event) => {
    this.setState({
      nextStep:event.target.getAttribute('data-step')
    })
   
  };

  render() {
    return (
      <React.Fragment>
        <Header
          title="Patient Symptoms Narrative"
          titleImage="ic-medical-result.png"
        />
        <Menu />
        <section className="sec--question sec--custom-question section-complain">
          <div className="banner">
            <div className="container">
              <img src="./../../../assets/img/bg/banner.jpg" alt="" />
            </div>
          </div>
          <div className="content">
            <div className="multybgRow">
              <ul className="checkList">
                <li>
                  <div className="checbox">
                    <input
                      className="custom--checkbox"
                      onClick={this.handleAction.bind()}
                      id={"checkbox-1"}
                      type="radio"
                      name="option"
                      data-step={'complain/add'}
                    />
                    <label htmlFor={"checkbox-1"}>{'Do you wish to add another chief complain?'}
                    </label>
                  </div>
                </li>
                <li>
                  <div className="checbox">
                    <input
                      className="custom--checkbox"
                      onChange={this.handleAction.bind()}
                      id={"checkbox-2"}
                      type="radio"
                      name="option"
                      key={'addComplain'}
                      data-step={'question'}
                    />
                    <label htmlFor={"checkbox-2"}>{'Add new questions for the already selected chief complain ?'}
                    </label>
                  </div>
                </li>
                <li>
                  <div className="checbox">
                    <input
                      className="custom--checkbox"
                      onChange={this.handleAction.bind()}
                      id={"checkbox-3"}
                      type="radio"
                      name="option"
                      data-step={'complain/modify'}
                    />
                    <label htmlFor={"checkbox-3"}>{'Modify responses given by patient?'}
                    </label>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </section>

        <div className="sec-btn">
          <Link name={'prev'} to={"#"} className="btn-img">
            <img src={require("../../assets/img/icons//ic-prev.png")} />
          </Link>
          <Link name={'next'} to='#' onClick={this.handleAction} onClick={this.goNextStep.bind()} className="btn-img">
            <img src={require("../../assets/img/icons/ic-next.png")} />
          </Link>
        </div>
      </React.Fragment>
    );
  }
}

export default Complains;
